(function () {
  if (window.PDW_SOCLOZ_INITIALIZED) return;
  window.PDW_SOCLOZ_INITIALIZED = true;

  const SOCLOZ_BASE =
    'https://api.socloz.com/v4/widget/reservation/creation';

  const SOCLOZ_APP_KEY =
    '3300482dad7c3a7143eeccddb48ef5fa';

  const SOCLOZ_COUNTRY = 'ES';
  const SOCLOZ_LOCALE = 'es_ES';
  const SOCLOZ_SERVICE = 'reservation';
  const SOCLOZ_ID_TYPE = 'part_num';

  let currentSoclozProductId = '';

  function getCurrentElements() {
    return {
      button: document.getElementById('reserve-in-store-btn'),
      overlay: document.getElementById('socloz-modal-overlay'),
      iframe: document.getElementById('socloz-iframe')
    };
  }

  function captureCurrentProductId() {
    const { button } = getCurrentElements();

    if (!button) return false;

    const productIdFromHtml = String(
      button.getAttribute('data-socloz-product-id') || ''
    ).trim();

    /*
     * Si el HTML contiene un pdw.model válido, lo guardamos siempre.
     *
     * Esto permite:
     * - conservarlo cuando cambia el color;
     * - sustituirlo cuando navegamos a otro producto.
     */
    if (productIdFromHtml) {
      if (productIdFromHtml !== currentSoclozProductId) {
        console.log(
          'SOCLOZ: identificador actualizado',
          currentSoclozProductId,
          '->',
          productIdFromHtml
        );
      }

      currentSoclozProductId = productIdFromHtml;
    }

    /*
     * Si el botón recién renderizado no trae identificador,
     * recuperamos el último válido.
     */
    if (currentSoclozProductId) {
      button.setAttribute(
        'data-socloz-product-id',
        currentSoclozProductId
      );

      button.disabled = false;

      button.classList.remove(
        'opacity-60',
        'cursor-not-allowed'
      );

      button.removeAttribute('title');

      return true;
    }

    button.disabled = true;

    button.classList.add(
      'opacity-60',
      'cursor-not-allowed'
    );

    button.title =
      'Este producto no está disponible para reserva en tienda';

    return false;
  }

  function buildSoclozUrl() {
    if (!captureCurrentProductId()) {
      return null;
    }

    const params = new URLSearchParams({
      _parent_url: window.location.href,
      app_key: SOCLOZ_APP_KEY,
      country: SOCLOZ_COUNTRY,
      locale: SOCLOZ_LOCALE,
      service: SOCLOZ_SERVICE,
      'product.id': currentSoclozProductId,
      'product.id_type': SOCLOZ_ID_TYPE
    });

    return `${SOCLOZ_BASE}?${params.toString()}#/product`;
  }

  function openModal(button) {
    const productIdAvailable = captureCurrentProductId();

    const { overlay, iframe } = getCurrentElements();

    if (!button || !overlay || !iframe) {
      console.error(
        'SOCLOZ: no se encuentra el botón, overlay o iframe'
      );

      return;
    }

    if (!productIdAvailable) {
      console.error(
        'SOCLOZ: no se ha podido recuperar el identificador del producto actual'
      );

      return;
    }

    const soclozUrl = buildSoclozUrl();

    if (!soclozUrl) {
      console.error(
        'SOCLOZ: no se ha podido construir la URL'
      );

      return;
    }

    console.log(
      'SOCLOZ: abriendo modal para',
      currentSoclozProductId
    );

    iframe.src = soclozUrl;
    overlay.style.display = 'block';

    button.setAttribute(
      'aria-expanded',
      'true'
    );

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    const { button, overlay, iframe } =
      getCurrentElements();

    if (overlay) {
      overlay.style.display = 'none';
    }

    if (button) {
      button.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    if (iframe) {
      iframe.src = '';
    }

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '#reserve-in-store-btn'
      );

      if (button) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openModal(button);

        return;
      }

      if (
        event.target.id ===
        'socloz-modal-overlay'
      ) {
        closeModal();
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      const { overlay } = getCurrentElements();

      if (
        event.key === 'Escape' &&
        overlay &&
        overlay.style.display === 'block'
      ) {
        closeModal();
      }
    }
  );

  function handleHashClose() {
    if (
      window.location.hash &&
      window.location.hash.includes('popupClose')
    ) {
      closeModal();

      const url = new URL(
        window.location.href
      );

      url.hash = '';

      window.history.replaceState(
        null,
        '',
        url.toString()
      );
    }
  }

  /*
   * Detecta cuándo el tema sustituye dinámicamente el HTML:
   * - cambio de color;
   * - navegación a otra PDP;
   * - renderizado de Combined Listings.
   */
  const observer = new MutationObserver(function () {
    captureCurrentProductId();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener(
    'shopify:section:load',
    captureCurrentProductId
  );

  window.addEventListener(
    'hashchange',
    handleHashClose
  );

  captureCurrentProductId();
  handleHashClose();
})();